import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default new Vuex.Store({
  state: {
    file: null,
    elements: [],
    title: null,
  },
  mutations: {
    submit(state, { file, elements }) {
      state.file = file;
      state.elements = elements;
    },
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin],
});
